import React from 'react';
import { Activity } from 'lucide-react';

const PlatformMetrics = ({ bookingsAnalytics = {} }) => {
  // Helper function to format currency
  const formatCurrency = (amount) => {
    if (amount === null || amount === undefined || amount === '') return '$0.00';
    const numAmount = typeof amount === 'string' ? parseFloat(amount) : Number(amount);
    if (isNaN(numAmount) || !isFinite(numAmount)) return '$0.00';
    return `$${numAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4 sm:p-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Platform Metrics</h2>
      <div className="space-y-4">
        <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
          <div>
            <p className="text-sm text-gray-600">Conversion Rate</p>
            <p className="text-xl font-bold text-gray-900 mt-1">
              {bookingsAnalytics.conversion_rate 
                ? `${Number(bookingsAnalytics.conversion_rate).toFixed(1)}%` 
                : 'N/A'}
            </p>
          </div>
          <Activity className="w-8 h-8 text-blue-600" />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div className="p-3 bg-gray-50 rounded-lg">
            <p className="text-xs text-gray-600 mb-1">Cancellation Rate</p>
            <p className="text-lg font-semibold text-gray-900">
              {bookingsAnalytics.cancellation_rate 
                ? `${Number(bookingsAnalytics.cancellation_rate).toFixed(1)}%` 
                : '0%'}
            </p>
          </div>
          <div className="p-3 bg-gray-50 rounded-lg">
            <p className="text-xs text-gray-600 mb-1">Avg Booking Value</p>
            <p className="text-lg font-semibold text-gray-900">
              {formatCurrency(bookingsAnalytics.average_value || 0)}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlatformMetrics;

